






import { Component, Mixins, Prop } from "vue-property-decorator";
import { TextStyle, TextAlignKinds } from "../../../domain/drawing";
import { RectangleAreaDrawableMixin } from "./mixins";

@Component
export default class TextAreaDrawer extends Mixins(RectangleAreaDrawableMixin) {
  @Prop()
  text: string;

  @Prop()
  textStyle: TextStyle;

  get textAlignmentStyles() {
    return {
      justifyContent: this.textAlignment,
      alignItems: this.verticalAlignment,
    };
  }

  get textStyles() {
    return {
      color: this.textStyle.color.value,
      fontFamily: this.textStyle.fontFamily,
      fontSize: this.textStyle.baseFontSize + "px",
      whiteSpace: "pre",
    };
  }

  get textAlignment(): "flex-start" | "center" | "flex-end" {
    if ((this.textStyle.textAlign & TextAlignKinds.Left) === TextAlignKinds.Left) {
      return "flex-start";
    } else if ((this.textStyle.textAlign & TextAlignKinds.Center) === TextAlignKinds.Center) {
      return "center";
    } else if ((this.textStyle.textAlign & TextAlignKinds.Right) === TextAlignKinds.Right) {
      return "flex-end";
    }
  }

  get verticalAlignment(): "flex-start" | "center" | "flex-end" {
    if ((this.textStyle.textAlign & TextAlignKinds.Top) === TextAlignKinds.Top) {
      return "flex-start";
    } else if ((this.textStyle.textAlign & TextAlignKinds.Middle) === TextAlignKinds.Middle) {
      return "center";
    } else if ((this.textStyle.textAlign & TextAlignKinds.Bottom) === TextAlignKinds.Bottom) {
      return "flex-end";
    }
  }
}
